import { twMerge } from 'tailwind-merge'

export function Skeleton({ className }: { className?: string }): JSX.Element {
  return (
    <div
      className={twMerge(`bg-gray-300 animate-pulse rounded-md`, className)}
    />
  )
}
